import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasTestSeriesTable from './BodmasTestSeriesTable';

const BodmasTestSeries = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Bodmas Test Series' parent='Bodmas Test Series' />
      <Container fluid={true}>
        <Row>
          <BodmasTestSeriesTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasTestSeries;
